import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { TaskDataTabs, TaskDialogComponent } from './task-dialog.component'
import { CreateTaskPayload, TaskView } from '@tokeet-frontend/tasks'

@Injectable({
  providedIn: 'root',
})
export class TaskDialogService {
  constructor(private dialog: MatDialog) {}

  open(taskId?: string, defaults: Partial<CreateTaskPayload> = {}, tab?: TaskDataTabs) {
    const defaultConfig: MatDialogConfig = {
      width: '800px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: { taskId, defaults, tab },
    }

    return this.dialog.open(TaskDialogComponent, defaultConfig)
  }
}
